module.exports = __webpack_public_path__ + "static/img/account.a78b0b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/account.png
// module id = 1463
// module chunks = 2